// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"2e58c0ff","854":"d59a2463"}[chunkId] + ".chunk.js";
};